import { effect, inject, Injectable, signal } from '@angular/core';
import { TestingAccessService } from './testing-access.service';

export interface GiactForcedCodeOption {
    id: number;
    label: string;
}

export const GIACT_FORCED_CODE_OPTIONS: GiactForcedCodeOption[] = [
    { id: 1, label: 'GS01' },
    { id: 2, label: 'GS02' },
    { id: 3, label: 'GS03' },
    { id: 4, label: 'GS04' },
    { id: 5, label: 'GP01' },
    { id: 6, label: 'RT00' },
    { id: 7, label: 'RT01' },
    { id: 8, label: 'RT02' },
    { id: 9, label: 'RT03' },
    { id: 10, label: 'RT04' },
    { id: 12, label: '_1111' },
    { id: 13, label: '_2222' },
    { id: 14, label: '_3333' },
    { id: 15, label: '_5555' },
    { id: 19, label: 'GN01' },
    { id: 20, label: 'GN05' },
    { id: 21, label: 'ND00' },
    { id: 22, label: 'ND01' },
];

@Injectable({
    providedIn: 'root',
})
export class GiactForcedCodeToggleService {
    private readonly STORAGE_KEY = 'isi-dtc-giact-forced-code-id';
    private testingAccess = inject(TestingAccessService);

    selectedId = signal<number | null>(null);

    constructor() {
        if (this.testingAccess.isEnabled()) {
            this.initializeState();

            effect(() => {
                const id = this.selectedId();
                if (id === null) {
                    localStorage.removeItem(this.STORAGE_KEY);
                } else {
                    localStorage.setItem(this.STORAGE_KEY, String(id));
                }
            });
        }
    }

    private initializeState(): void {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        if (stored === null) return;
        const parsed = Number(stored);
        if (Number.isFinite(parsed) && GIACT_FORCED_CODE_OPTIONS.some((option) => option.id === parsed)) {
            this.selectedId.set(parsed);
        }
    }

    setSelectedId(id: number | null): void {
        this.selectedId.set(id);
    }
}
